<div class=" banner_header">
    <div class="col-md-12">
        <h2>Exam Details</h2>
    </div>
</div>


  
<section class="section_box_one">
    <div class="container">
      <h2>About Our Online CBT Examination system</h2>
      <div class="row">
        <div class="col-md-4">
          <h3>CBT</h3>
          <p>
            CBT – 100 Marks – as per guidelines, Duration: 1 ½ hours , Topic for CBT Training Methodology, Employability Skills, Workshop Calculation & Science in the ratio of 20:20:10 and Total questions – 50 with each 2 marks </p>
  
  
        </div>
        <div class="col-md-4">
          <h3>Guidelines</h3>
          <p>
            Use safe exam browser application for live exam
          </p>
          <p> <a href="https://safeexambrowser.org/download_en.html" target="_blank"> Click here to Download and Install
              Safe Exam Browser</a></p>
          <p> <a href="https://nimionlinetesting.in/aitt_exam/SebClientSettingsnewforsession.seb"> If already Installed
              click here to download Configuration file </a></p>
        </div>
        <div class="col-md-4">
          <h3>Mock Test</h3>
          <p>
            A Mock test of the actual CBT interface in provided to the students for getting familiarized with the system.
          </p>
          <p>Students can use the following mock test user id and password to access the same <a class="click_here" href="https://www.nimionlinetesting.in/aitt_exam/" target="_blank">
              Click here</a>
          </p>
        </div>
      </div>
  
      
    </div>
  </section>
  <hr>

  <h1 class="head_cls_main" style="text-align: center;">  
    Upcoming CBT Exam
  </h1>

  <!--Content Start-->
<section class="section_box_one">
  <div class="container">
    <h2>Flexi-MoU Centurion University CBT Exam</h2>
    <div class="row">
      <div class="col-md-4">
        <h3>Examination Topic</h3>
        <p>
          Related to the subjects </p>
      </div>

      <div class="col-md-4">
        <h3>Date of Exam Scheduled</h3>
        <p>
          CBT Exam is scheduled for 4-12-2021 to 6-12-2021</p>
      </div>      
     
      <div class="col-md-4">
        <h3>More Details</h3>

        <p>
          will be announced shortly
           
         </p>

       
      </div>
    </div>

    
  </div>
</section>
<!--Content End-->

  <!--Content Start-->
<section class="section_box_one">
  <div class="container">
    <h2>IBM Advanced Diploma CBT Exams</h2>
    <div class="row">
      <div class="col-md-4">
        <h3>Examination Topic</h3>
        <p>
          Related to IBM Advanced diploma subjects </p>
      </div>

      <div class="col-md-4">
        <h3>Date of Exam Scheduled</h3>
        <p>
          CBT Exam is scheduled for 6-12-2021 to 14-12-2021</p>
      </div>      
     
      <div class="col-md-4">
        <h3>More Details</h3>

        <p>
          will be announced shortly
           
         </p>

       
      </div>
    </div>

    
  </div>
</section>
<!--Content End-->

<!--Content Start-->
<section class="section_box_one">
  <div class="container">
    <h2>All India Trade Test of Craft Instructors under CITS Regular/Supplementary exam in the month of November 2021</h2>
    <div class="row">
      <div class="col-md-4">
        <h3>Examination Topic</h3>
        <p>
          CBT examination of Theoretical subjects (Trade Theory-I,II, Trade Skill-I,II, Workshop Calculation & Science, Workshop Calculation, Workshop Science, Vocational Science & Calculation, Soft Skill & English Communication and Training Methodology  </p>
      </div>

      <div class="col-md-4">
        <h3>Date of Exam Scheduled</h3>
        <p>
          CBT Exam is scheduled for 23-11-2021 to 28-11-2021</p>
      </div>   

      <div class="col-md-4">
        <h3>More Details</h3>
       

        <p>
          For More Details CITS <a routerLink="/aboutcbt">Click here</a>
           
         </p>

        <p>
         For More Exam Details <a target="_blank" href="assets/pdf/ScannerGo_23Oct2021_543210.pdf">Click here</a>
          
        </p>
        <p>For Hall Ticket download <a target="_blank" href="https://nimionlineadmission.in/2020halltickets/">Click here</a> </p>
        <p>Hall tickets for left over candidates <a target="_blank" href="https://nimionlineadmission.in/2020halltickets_v2/">Click here</a> </p>
        <p>CBT exams for leftover candidates scheduled from 29th November to 01st December 2021</p>

      </div>
    </div>

    
  </div>
</section>
<!--Content End-->

  
   
      
  <hr>

  <h1 class="head_cls_main_or">  
    Completed CBT Exams
  </h1>

    <!--Content Start-->
    <section class="section_box_one">
      <div class="container">
        <h2>Oxygen - 22-10-2021</h2>
        <div class="row">
          <div class="col-md-4">
            <h3>Question and Time</h3>
            <p>
              30 questions and 60 minutes </p>
    
    
          </div>
          <div class="col-md-4">
            <h3>Examination  Topic        </h3>
            <p>
              Related to the Course       
            </p>
            
          </div>
          <!-- <div class="col-md-4">
            <h3>Scheduled</h3>
            <p>
              CBT Exam is scheduled for 14-09-2021
            </p>
           
          </div> -->
        </div>
    
        
      </div>
    </section>
    <!--Content End-->

 <!--Content Start-->
 <section class="section_box_one">
  <div class="container">
    <h2>Consultants (IT Support ) - 16-09-2021</h2>
    <div class="row">
      <div class="col-md-4">
        <h3>Consultant (IT) - 30 posts</h3>
        <p>
          CBT - 120 Marks - as per guidelines, Duration 2 hours  </p>


      </div>
      <div class="col-md-4">
        <h3>Examination  Topic</h3>
        <p>
          English Language - 15 questions, Logical Reasoning - 15 questions, Quantitative Aptitude & Data Interpretation - 15 Marks, Computer Knowledge - 15 Marks
        </p>
      
      </div>
      <div class="col-md-4">
        <h3>Date of Exam Scheduled</h3>
        <p>
          CBT Exam is scheduled for 16-09-2021
        </p>
      
      </div>
    </div>
  </div>
</section>

<!--Content End-->

  <!--Content Start-->
  <section class="section_box_one">
    <div class="container">
      <h2>Maruthi Flexi - 14-09-2021</h2>
      <div class="row">
        <!-- <div class="col-md-4">
          <h3>JVC - 240 Posts</h3>
          <p>
            CBT – 100 Marks – as per guidelines, Duration: 1 ½ hours </p>
  
  
        </div> -->
        <div class="col-md-4">
          <h3>Examination  Topic</h3>
          <p>
            Related to the Trade
          </p>
          
        </div>
        <!-- <div class="col-md-4">
          <h3>Scheduled</h3>
          <p>
            CBT Exam is scheduled for 14-09-2021
          </p>
         
        </div> -->
      </div>
  
      
    </div>
  </section>
  <!--Content End-->
  
  <!--Content Start-->
  <section class="section_box_one">
    <div class="container">
      <h2>Junior Vocational Consultants - 14-09-2021</h2>
      <div class="row">
        <div class="col-md-4">
          <h3>JVC - 240 Posts</h3>
          <p>
            CBT – 100 Marks – as per guidelines, Duration: 1 ½ hours </p>
  
  
        </div>
        <div class="col-md-4">
          <h3>Examination  Topic</h3>
          <p>
            Topic for CBT Training Methodology, Employability Skills, Workshop Calculation & Science in the ratio of 20:20:10 and Total questions – 50 with each 2 marks
          </p>
          
        </div>
        <div class="col-md-4">
          <h3>Date of Exam Scheduled</h3>
          <p>
            CBT Exam is scheduled for 14-09-2021
          </p>
         
        </div>
      </div>
  
      
    </div>
  </section>
  <!--Content End-->
  

  
  
  <!--Content Start-->
  <section class="section_box_one">
    <div class="container">
      <h2>Consultants (Technical Support ) - 15-09-2021</h2>
      <div class="row">
        <div class="col-md-4">
          <h3>Consultant (IT) - 48 posts</h3>
          <p>
            CBT - 120 Marks - as per guidelines, Duration 2 hours  </p>
  
  
        </div>
        <div class="col-md-4">
          <h3>Examination  Topic</h3>
          <p>
            English Language - 15 questions, Logical Reasoning - 15 questions, Quantitative Aptitude & Data Interpretation - 15 Marks, Computer Knowledge - 15 Marks
          </p>
          <p>Note: No 4 Topic will be different only</p>
          <p>Note: Total Questions - 60 with each 2 marks</p>
        
        </div>
        <div class="col-md-4">
          <h3>Date of Exam Scheduled</h3>
          <p>
            CBT Exam is scheduled for 15-09-2021
          </p>
        
        </div>
      </div>
    </div>
  </section>
  
  <!--Content End-->
  
  <!-- <section class="section_box_one">
    <div class="container">
      <h2>All India Trade Test 2020 - Computer Based Test</h2>
      <div class="row">
        <div class="col-md-4">
          <h3>Online Examinations</h3>
          <p>
            AITT exam are being conducted online for all ITI students in two shift per day. </p>
          <p>The theory exam comprises of 60 questions for Non - Engineering trades & Engineering second year trades and
            80 questions for Engineering trades. <span class="click_here" routerLink="/aboutcbt"
              routerLinkActive="active"> Read More</span>
          </p>
  
        </div>
        <div class="col-md-4">
          <h3>Guidelines</h3>
          <p>
            Use safe exam browser application for live exam
          </p>
          <p> <a href="https://safeexambrowser.org/download_en.html" target="_blank"> Click here to Download and Install
              Safe Exam Browser</a></p>
          <p> <a href="https://nimionlinetesting.in/aitt_exam/SebClientSettingsnewforsession.seb"> If already Installed
              click here to download Configuration file </a></p>
        </div>
        <div class="col-md-4">
          <h3>Mock Test</h3>
          <p>
            A Mock test of the actual CBT interface in provided to the students for getting familiarized with the system.
          </p>
          <p>Students can use the following mock test user id and password to access the same <span class="click_here">
              Click here</span>
          </p>
        </div>
      </div>
    </div>
  </section> -->
  <!--Content End-->
  

  
  

  


<style>
    .section_box_one {
        padding: 30px 0px;
    }

    .section_box_one h2 {
        border-bottom: 5px solid #000;
        padding-bottom: 5px;
        width: fit-content;
        margin: 0 auto 30px;
    }

    .banner_header {
        background: #2955a9;
        padding: 10px 0px;
        text-align: left;
        color: #fff;
        margin: 0px;
    }

    .banner_header h2 {
        font-size: 21px;
    }

    .download_section {
        padding: 40px 0px;
        text-align: center;
    }

    .steps {
        left: 0px;
        height: 50px;
        width: 50px;
        background-color: #29ab55;
        border-radius: 50%;
        display: inline-block;
        font-size: 31px;
        text-align: center;
        color: #fff;
        position: absolute;
    }

    .step_cls {
        padding: 0px 70px 0px;
    }

    .click_here {
        background: #2955a9;
        padding: 5px 15px;
        color: #fff;
        font-size: 10px;
        font-weight: 500;
        border-radius: 10px;
        width: fit-content;
        cursor: pointer;
    }

    .click_here:hover {
        background-color: #000;
    }

    .payment_cls {
        padding: 30px 0px 120px;
    }
</style>
